import {
  Check,
  CircleAlert,
  Clock,
  ClockFading,
  Coins,
  FileText,
  Headphones,
  MessageSquare,
  RotateCw,
  User,
  type LucideIcon,
} from 'lucide-react';

import type { LedgerStateValue } from './api/schemas';

/** One icon per job type this screen can show a chip for. `job_type` is a bare `str` on the wire
 *  (CO-5's own schema names no closed set), so an unknown value falls back to `FileText` rather
 *  than throwing -- a new job type appearing here is a cosmetic gap, not a crash. */
const JOB_TYPE_ICON: Record<string, LucideIcon> = {
  posts: FileText,
  comments: MessageSquare,
  stories: ClockFading,
  audio_fanout: Headphones,
  profile_tracked: User,
};

export function jobTypeIcon(jobType: string): LucideIcon {
  return JOB_TYPE_ICON[jobType] ?? FileText;
}

/** `state`'s own icon, before the campaign-blocked override (`sem crédito`) is applied. */
const STATE_ICON: Record<LedgerStateValue, LucideIcon> = {
  planned: Clock,
  dispatched: RotateCw,
  done: Check,
  failed: CircleAlert,
};

/** The status icon a chip renders: `blocked` overrides every non-terminal state to `sem
 *  crédito` (Coins), because a blocked campaign's planned slots will not run regardless of what
 *  `state` says today. A `done` or `failed` slot already happened and keeps its own icon. */
export function chipStatusIcon(state: LedgerStateValue, blocked: boolean): LucideIcon {
  if (blocked && (state === 'planned' || state === 'dispatched')) return Coins;
  return STATE_ICON[state];
}
